// SETUP COLORS

export const GREY = {
    0: '#FFFFFF',
    25: '#FCFCFD',
    50: '#F9FAFB',
    100: '#F2F4F7',
    200: '#E4E7EC',
    300: '#D0D5DD',
    400: '#98A2B3',
    500: '#667085',
    600: '#475467',
    700: '#344054',
    800: '#2D2939',
    900: '#101828'
};

export const PURPLE = {
    25: '#FCFAFF',
    50: '#F9F4FF',
    100: '#F4EBFF',
    200: '#E9D7FE',
    300: '#D5BBFB',
    400: '#B692F6',
    500: '#9E77ED',
    600: '#7F56D9',
    700: '#6941C6',
    800: '#53389E',
    900: '#42307D'
};
export const GREEN = {
    25: '#F6FEF9',
    50: '#ECFDF3',
    100: '#D1FADF',
    200: '#A6F4C5',
    300: '#6CE9A6',
    400: '#32D583',
    500: '#32D583',
    600: '#039855',
    700: '#027948',
    800: '#05603A',
    900: '#054F31'
};
export const ORANGE = {
    25: '#FFFCF5',
    50: '#FFFAEB',
    100: '#FEEFC7',
    200: '#FEDF89',
    300: '#FEC84B',
    400: '#FDB022',
    500: '#F79009',
    600: '#DC6803',
    700: '#B54708',
    800: '#93370D',
    900: '#792E0D'
};
export const RED = {
    25: '#FFF5F6',
    50: '#FFF1F3',
    100: '#FFE4E8',
    200: '#FECCD6',
    300: '#FEA3B4',
    400: '#FD6F8E',
    500: '#F63D68',
    600: '#E31B53',
    700: '#C01048',
    800: '#A11043',
    900: '#A11043'
};
export const AQUA = {
    25: '#F4FFFF',
    50: '#EEFFFF',
    100: '#B1FFFF',
    200: '#7BF3F7',
    300: '#56E1E5',
    400: '#20CED3',
    500: '#0DBBC0',
    600: '#17989E',
    700: '#17989E',
    800: '#14595F',
    900: '#0E494F'
};
export const GOLD = {
    25: '#FFFAF5',
    50: '#FFF4EB',
    100: '#FFE8D1',
    200: '#FFDFA6',
    300: '#FFD06C',
    400: '#d7b981',
    500: '#c69b4c',
    600: '#A67B2C',
    700: '#8C6420',
    800: '#6E4B1A',
    900: '#5A3E1A'
};

// SETUP GRADIENTS
const GRADIENTS = {
    red: 'linear-gradient(257.04deg, #FD6F8E 0%, #E31B53 100%)',
    aqua: 'linear-gradient(225deg, #6CE9A6 0%, #0DBBC0 100%)',
    blue: 'linear-gradient(270deg, #20CED3 0%, #207DFF 100%)',
    turquoise: 'linear-gradient(270deg, #6CE9A6 0%, #0DBBC0 100%)',
    gold: 'linear-gradient(270deg, #91733D 0%, #BA9B61 100%)',
    grey: 'linear-gradient(270deg, #E4E7EC 0%, #E4E7EC 100%)'
};

export const redGradient = GRADIENTS.red;
export const aquaGradient = GRADIENTS.aqua;
export const blueGradient = GRADIENTS.blue;
export const turquoiseGradient = GRADIENTS.turquoise;
export const goldGradient = GRADIENTS.gold;
export const greyGradient = GRADIENTS.grey;

const GRADIENTCOLORS = {
    red: ['#FD6F8E', '#E31B53'],
    aqua: ['#6CE9A6', '#0DBBC0'],
    blue: ['#20CED3', '#207DFF'],
    turquoise: ['#6CE9A6', '#0DBBC0'],
    gold: ['#91733D', '#BA9B61'],
    grey: ['#98A2B3', '#98A2B3']
};

export const redGradientColors = GRADIENTCOLORS.red;
export const aquaGradientColors = GRADIENTCOLORS.aqua;
export const blueGradientColors = GRADIENTCOLORS.blue;
export const turquoiseGradientColors = GRADIENTCOLORS.turquoise;
export const goldGradientColors = GRADIENTCOLORS.gold;
export const greyGradientColors = GRADIENTCOLORS.grey;
